import styled from 'styled-components';

export const ProductImageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
`;

export const ProductImageElement = styled.img`
  max-width: 100%;
  height: auto;
  object-fit: contain;
`;
